<template>
    <section>
        <div>
            <div class="box-header">
                <h3 class="box-title" style="color:white">Trip Details</h3>
            </div>
            <div class="box-body">                                      
                <div class="row">
                   <!--  <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                    </div> -->
                </div>
                <div class="row" :class="addButtonClass">
                    <button class="btn btn-primary glyphicon glyphicon-refresh" value="Refresh Page" @click ="refresh" style="float: right; margin-right:20px"></button>
                </div>
                <div>
                    <v-server-table ref="triplocationTable" url :columns="columns" :options="options" @loaded="onLoaded"> 
                        <template slot="beforeBody">
                            <tr v-if="loading" class="VueTables__no-results">
                                <td class="text-center" colspan="9">
                                    <pulse-loader></pulse-loader>
                                </td>
                            </tr>
                        </template>
                    </v-server-table>       
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import axios from 'axios';
import moment from 'moment';
import Vue from 'vue'
export default {
    name: 'TripLocationLog',
    data (){
    return {
    USER_ROLES : USER_ROLES,
    loading: null,
        triplocationTable: null,
        addressData:[],
    columns: ['recordedTime','latitude','longitude','batteryStatus','address'],
    // customFilters: [status=='Halt'],
    options: {
      highlightMatches: true,
      sortable: ['recordedTime','longitude','latitude','batteryStatus'],
      headings: {
                latitude: 'Latitude',
                longitude: 'Longitude',
        recordedTime: 'Recorded Time ',
                batteryStatus: 'Battery',
                address: 'Address'
            },
            templates:{
               recordedTime(row,query){
                   return moment(query.recordedTime, moment.ISO_8601).format('DD-MM-YY hh:mm:ss')
               },
                
                    // console.log(query.latitude,query.longitude)
                    // return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${query.latitude},${query.longitude}&key=AIzaSyBvu5T76L9QqcebnQuUYUAAsdrI-DmvGK4`)
                    // .then(response => {
                    //     console.log("address response",response)
                    //     if(response.data.error_message !== "This API project is not authorized to use this API."){
                    //        console.log("ASDFASf",  response.data.results[0].address_components[0].long_name)
                    //        return  response.data.results[0].address_components[0].long_name
                    //     }
                    // })
                   // return this.addressDa
            },
            requestFunction: request => {
                const params = {};
                params.$page = request.page;
                params.$limit = request.limit;
                params.tripID = this.$route.params._id;
                this.loading = true;
                return this.$triplocationDataRepository.list(params)
                .catch(error => {
                    console.error('tripException.requestFunction-error:', error);
                    this.$snotify.error('Get Location', 'Error!');
                });
            },
            responseAdapter: response => {
                this.loading = false;
                console.log("triplog response",response)
                return {
                    data: response.data.docs,
                    count: response.data.items.total,
                };
            },
        },
        triplocation: {}
        }
    },
    methods : {
        onLoaded() {
            this.triplocationTable = this.$refs.triplocationTable;
        },
        refresh(){
            this.$refs.triplocationTable.refresh();
        }
    },
    computed: {
    addButtonClass() {
      if (this.triplocationTable) {
        return this.triplocationTable.count > this.triplocationTable.limit ||
          this.triplocationTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    }
}
</script>

<style scoped>
.box-header{
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
}
</style>


// WEBPACK FOOTER //
// TripLocationLog.vue?fbd08628